<template>
  <div class="fancy-box-gallery" itemscope itemtype="http://schema.org/Thing">
    <div v-if="singleImages && singleImages.length > 0" class="img-gallery">
      <a class="fancybox d-block" :href="singleImages[0].url" data-fancybox="gallery" style="pointer-events: none;">
        <lazy-img :alt="getAltText(middleSingleImage[0])" ref="itemLazyImage"
          picture-class="img-gallery-big-one img-fluid" :image-url="middleSingleImage[0].url"
          :width="getImageWidth(middleSingleImage[0])" :height="getImageHeight(middleSingleImage[0])">
        </lazy-img>
      </a>
    </div>
    <div class="thumbs" v-if="carouselImages.length > 0">
      <div class="thumb-list">
        <div class="thumb" v-for="(imagePreview, index) in carouselImages" :key="index" v-if="index>0">
          <div class="thumb-image" :style="{'background-image': 'url(' + imagePreview.url + ')'}">
            <a class="fancybox position-relative d-block h-100" :href="singleImages[index].url" data-fancybox="gallery"
              style="pointer-events: none;"></a>
          </div>
        </div>
        <div class="thumb" v-if="videoCode">
          <div class="thumb-image">
            <a class="fancybox position-relative d-block h-100" :href="videoUrl" data-fancybox="gallery"
              style="pointer-events: none;">
              <i class="fa fa-play-circle-o fa-3x"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isNullOrUndefined } from "../../helper/utils";

export default {
  props: {
    maxQuantity:
        {
          type: Number,
          default: 20
        },
    imageUrlAccessor:
        {
          type: String,
          default: "url"
        },
    videoCode:
        {
          type: String,
          default: ""
        },
    showThumbs:
        {
          type: Boolean,
          default: true
        },
    showDots:
        {
          type: Boolean,
          default: true
        },
    animationStyle:
        {
          type: String,
          default: "standard"
        },
    pluginPath:
        {
          type: String,
          default: ""
        }
  },

  inject: {
    itemId: {
      default: null
    }
  },

  data()
  {
    return {
      currentItem: 0,
      initialized: false
    };
  },

  computed:
      {
        currentVariation()
        {
          return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },

        carouselImages()
        {
          return this.$options.filters.itemImages(
              this.currentVariation.images,
              "urlPreview"
          ).slice(0, this.maxQuantity);
        },

        singleImages()
        {
          return this.$options.filters.itemImages(
              this.currentVariation.images,
              this.imageUrlAccessor
          ).slice(0, this.maxQuantity);
        },

        middleSingleImage()
        {
          return this.$options.filters.itemImages(
              this.currentVariation.images,
              "urlSecondPreview"
          ).slice(0, 1);
        },

        videoUrl()
        {
          return `https://www.youtube.com/watch?v=${this.videoCode}&rel=0&showinfo=1`;
        }
      },

  watch: {
    currentVariation:
        {
          handler(val, oldVal)
          {
            if (val !== oldVal)
            {
              setTimeout(() =>
              {
                this.reInitialize();
              }, 1);
            }
          },
          deep: true
        }
  },

  mounted()
  {
    this.$nextTick(() =>
    {
      this.loadFancyBox().then(() =>
      {
        this.initFancyBox();
        $('.fancy-box-gallery a').css('pointer-events', 'auto');
      })
          .catch(event =>
          {
            console.log("error while loading fancybox", event);
          });
    });
  },

  methods:
      {
        getImageCount()
        {
          return this.carouselImages.length > this.maxQuantity ? this.maxQuantity : this.carouselImages.length;
        },

        reInitialize()
        {
          this.initFancyBox();
        },

        initFancyBox()
        {
          $.fancybox.defaults.loop = "true";

          $().fancybox({
            selector : '.fancy-box-gallery a',
            backFocus : false,
            hash   : false,
            thumbs : {
              autoStart : false
            },
            loop: true,
            buttons : [
              'zoom',
              'slideShow',
              'fullScreen',
              'thumbs',
              'close'
            ]
          });
        },

        getAltText(image)
        {
          return image && image.alternate ? image.alternate : this.$options.filters.itemName(this.currentVariation);
        },

        getImageName(image)
        {
          return image && image.name ? image.name : this.$options.filters.itemName(this.currentVariation);
        },

        getImageWidth(image)
        {
          return image && image.width ? image.width : this.$options.filters.itemImageWidth(this.carouselImages);
        },

        getImageHeight(image)
        {
          return image && image.height ? image.height : this.$options.filters.itemImageHeight(this.carouselImages);
        },

        loadFancyBox()
        {
          return new Promise((resolve, reject) =>
          {
            let script = document.querySelector("script#fancyboxscript");

            if (!isNullOrUndefined(script))
            {
              resolve();
            }
            else
            {
              const script = document.createElement("script");

              script.type = "text/javascript";
              script.id = "fancyboxscript";
              script.src = `${ this.pluginPath }/js/dist/fancybox.min.js`;

              script.addEventListener("load", () => resolve(), false);
              script.addEventListener("error", event => reject(event), false);

              document.body.appendChild(script);
            }
          });
        }
      }
}
</script>
